import {h} from '@stencil/core';
import {GuidedUiNoResultMessage} from '../../models/Guided.schema';
import type { GuidedV2FactoryState } from '../../models/ui';
import { RegisterType } from '../component-registry';
import {onlyMatchingSource} from '../../utils';
import {NoResultMessage} from './no-results-message';

export class GuidedV2NoResultMessage{

  @RegisterType(GuidedUiNoResultMessage.type)
  render(inputData:GuidedUiNoResultMessage, state: GuidedV2FactoryState){
      const {
        itemSources,
        message,
        messageName,
        subTitle
      } = inputData; //comes from configuration

      const {
        results,
        searchTerm,
        labelProvider,
        eventEmitters,
      } = state;

      const foundResults = results.filter(onlyMatchingSource(itemSources));

      if(foundResults.length > 0)
        return <div data-message="results found, not showing message"></div>;

      return <NoResultMessage
        message={labelProvider(`guided-v2.no-links-message.${messageName}`,message)}
        searchTerm={searchTerm}
        eventEmitters={eventEmitters}
        subTitle={subTitle}
      ></NoResultMessage>;

  }

}
